import { apiRequest } from "../client";

export interface CustomerAppUser {
  guid: string;
  idCard: string;
  firstName: string;
  lastName: string;
  mobile: string;
  userEmail: string;
  hasPin: boolean;
}

/** The signed-in customer, resolved from the access token / webview session. */
export function getProfile(): Promise<CustomerAppUser> {
  return apiRequest("POST", "/v1/auth/me");
}

export function checkPin(body: {
  guid: string;
  pin: string;
}): Promise<Record<string, unknown>> {
  return apiRequest("POST", "/v1/auth/customer/check_pin", body);
}
